import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatRipple, MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from '../../../modules/shared/shared.module';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'ig-confirm-dialog',
  standalone: true,
  imports: [
    MatRipple,
    MatRippleModule,
    MatIconModule,
    SharedModule,
    CommonModule,
  ],
  templateUrl: './confirm.dialog.component.html',
  styleUrl: './confirm.dialog.component.scss',
  host: {
    class:
      'w-fit h-fit absolute z-[100] block rounded border border-[lightgray] bg-white py-3 px-4 text-gray-600 shadow-md',
  },
})
export class ConfirmDialogComponent {
  @Input() isShowIcon = true;
  @Input() text = 'Are you sure?';
  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();
}
